import logo from 'assets/images/kollectiff.svg';
import video from 'assets/videos/k-homepage.mp4';
import useVideoStore from 'stores/videoStore';
import { motion } from 'framer-motion';

export default function Hero() {
  const setVideoLoaded = useVideoStore((state) => state.setVideoLoaded);

  return (
    <div className="home-hero">
      <video
        autoPlay
        playsInline
        muted
        loop
        id="background-video"
        onLoadedData={() => {
          console.log('🎥 Video cargado');
          setVideoLoaded();
        }}
      >
        <source src={video} type="video/mp4" />
        Tu navegador no soporta videos en HTML5.
      </video>

      <div className="container hero-content">
        <h1 className="sr-only">Kollectiff</h1>
        <motion.img
          src={logo}
          alt=""
          className="max-w-[326px]"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2, ease: "easeOut" }}
        />

        <motion.p
          className="tagline"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4, ease: "easeOut" }}
        >
          A Creative Technology Company
        </motion.p>
      </div>
    </div>
  );
}
